import { render, staticRenderFns } from "./AppVersionUpgradeLogForm.vue?vue&type=template&id=016943fa&"
import script from "./AppVersionUpgradeLogForm.vue?vue&type=script&lang=js&"
export * from "./AppVersionUpgradeLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports